var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedCone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 41 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0106 1.88509L3.32364 14.0469C2.14173 15.7016 3.32454 18 5.35797 18H35.414C37.4898 18 38.6613 15.6166 37.3935 13.973L28.256 2.12816C27.5262 1.18217 26.2316 0.910509 25.0773 1.21905C21.7688 2.10348 17.8523 1.58667 14.6564 0.889187C13.653 0.670199 12.6076 1.04936 12.0106 1.88509Z",
    fill: "#ED4863"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2C28 3.10457 24.4183 4 20 4C15.5817 4 12 3.10457 12 2C12 1 15.5817 0 20 0C24.4183 0 28 0.89543 28 2Z",
    fill: "#A41129"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 16C38 18.7614 30.165 21 20.5 21C10.835 21 3 18.7614 3 16C3 13.2386 10.835 11 20.5 11C30.165 11 38 11.5 38 16Z",
    fill: "#ED4863"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCone);
export default __webpack_public_path__ + "static/media/red-cone.02aa84ad0518eff370f59e6855b24b1b.svg";
export { ForwardRef as ReactComponent };